const TARGET = [
    "b9cb4775-35df-442f-845f-cb291522b2d0",
    "e286fcf1-701b-4764-925b-279fbfd50bea",
    "c19e85ec-577f-495d-9c81-8739941280f7",
    "351ee23f-9edb-453b-a54b-20d7c98b0588",
    "4b1b803b-077c-4129-9bd9-66b56c4f6785",
    "e46957fa-2291-4b8b-9aa1-7790ecd1aa36",
    "9c471d64-476e-4925-b8d3-ec311ba7ad89",
    "6ef52094-58b2-48ac-98f8-515c8bc11d82",
    "c80bfa78-1990-4e63-996f-c05a5583b5e6",
    "de53c62a-1f4c-4142-87db-eb01ab70e558",
    "236af972-5740-4313-bdcf-69fbb98693b8",
    "6e5f2ee8-2a7b-4e01-a718-a55a0242cfe7",
    "3d2b868f-b7b1-4dde-98d9-cd06a8d8d404",
    "92a77b6f-578f-411e-b823-c6707bee8c63",
    "e0497049-aa02-43ac-a3c0-2ec8eafbc3c9",
    "90d438f4-76fb-4546-91a7-24f2b43d22ef",
    "a844e3c9-cf54-49e5-8402-c8855e0bb08e",
    "b6071141-f7e6-4b69-a218-761c91e48cd3",
    "37391c30-6352-4f15-b3d3-aad5bba4d0f4",
    "4b23703a-b0c1-45f3-bc94-61a6a5bf2210",
    "3d02f724-2c2a-41f5-83fa-8737603afd7f",
    "1049d2b4-4c23-4f6b-887a-878e6603bad6",
    "a269038b-aae3-4bf4-91ad-4b93afb73895",
    "17a87cd7-e911-4342-b23a-a0ff353e150b",
    "c7413bf6-67d7-4996-b5f4-a9fd8714748d",
    "b0ad37bc-9fe5-46df-b2c3-74f7f2824060",
    "dc512254-36f0-4632-884f-4da91e257f1f"
]

export const isTargetForApologyForMonthError = (sub) => {
    return TARGET.includes(sub);
}